import React, { useEffect, useRef, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import CustomToolTip from '../common/CustomToolTip';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { isEmpty, isNil } from 'lodash';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';
import { updateAsset } from '../../redux/actions/manageAssetActions';
import { makeStyles } from '@material-ui/core/styles';
import { jiraDomainUrl } from '../../Constants/Api';
import { openErrorSnackBar } from '../../redux/actions/snackBarActions';

const useStyles = makeStyles((theme) => ({
	root: {
		'& > *': {
			margin: theme.spacing(1),
		},
	},
}));

const toolTip = 'view this JIRA';
const toolTipDisable = 'No Jira Available';
// Editable jira txt
const EditableJiraTxt = ({ asset, setEditable }) => {
	const { jiraTask } = asset;
	const jiraTxtBox = useRef(null);
	const [val, setVal] = useState(jiraTask);
	const dispatch = useDispatch();
	useEffect(() => {
		// set the focus on the text box in edit mode.
		jiraTxtBox.current.getElementsByTagName('input')[0].focus();
	}, []);
	const handleChange = (event) => {
		const jira = event.target.value;
		setVal(jira);
	};
	const handleBlur = () => {
		// Validate JIRA task
		const regex = /[A-Z]{2,}-\d+/g;
		if ((regex.exec(val) && val.length < 10) || val === '') {
			setEditable(false);
			// dispatch action to update Manage Asset jiraTask field.
			// Only updated redux store when there is a change in JIRA task.
			if (val !== jiraTask) {
				const updatedAsset = { ...asset, jiraTask: val };
				dispatch(updateAsset(updatedAsset));
			}
		} else {
			dispatch(openErrorSnackBar('Jira task invalid format'));
		}
	};
	return (
		<TextField
			id="jira-editable-txt"
			variant="outlined"
			color="primary"
			value={val}
			onChange={handleChange}
			onBlur={handleBlur}
			ref={jiraTxtBox}
			size="small"
		/>
	);
};
// JIRA Link component
const AssetJiraLink = ({ asset, hideEditBtn }) => {
	const { jiraTask } = asset;
	const [isEditable, setEditable] = useState(false);
	const classes = useStyles();
	let jiraLink = jiraTask || '';
	const handleJiraBtnLinkOnClick = () => {
		// Open JIRA link in a new Tab.
		// TODO: remove this browse link here, once it is coming back from backend.
		window.open(`${jiraDomainUrl}${jiraLink}`);
	};
	let disableJiraTicket = false;
	// Checking if jira Task is null or undefined.
	if (isNil(jiraTask) || isEmpty(jiraTask)) {
		disableJiraTicket = true;
	}
	const jiraBtnTxt = `JIRA ${jiraLink}`;
	// In edit mode only return JIRA editable input box.
	if (isEditable) {
		return <EditableJiraTxt asset={asset} setEditable={setEditable} />;
	}

	const EditJiraBtn = () => {
		// hide edit button on asset snapshot drawer on search results page.
		if (!hideEditBtn) {
			return (
				<CustomToolTip
					title={'Click here to edit Jira'}
					InnerComponent={
						<Button startIcon={<EditIcon />} color="primary" size="small" onClick={() => setEditable(true)}>
							Edit Jira
						</Button>
					}
				/>
			);
		}
		return null;
	};

	return (
		<div data-cy="jira-link" className={classes.root}>
			<CustomToolTip
				title={disableJiraTicket ? toolTipDisable : toolTip}
				InnerComponent={
					<Button
						startIcon={<OpenInNewIcon />}
						variant="outlined"
						color="primary"
						size="small"
						disabled={disableJiraTicket}
						onClick={handleJiraBtnLinkOnClick}
					>
						{jiraBtnTxt}
					</Button>
				}
			/>
			<EditJiraBtn />
		</div>
	);
};

export default AssetJiraLink;
